import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {bindActionCreators} from 'redux'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {FusePageSimple, FuseAnimate} from '../../../../@fuse/index'

// Redux
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import ReduxVip from '../../../../store/actionreducers/vip'
import ReduxGroupType from '../../../../store/actionreducers/groupType'
import ReduxMissionPriceType from '../../../../store/actionreducers/missionPriceType'
import ReduxCompany from '../../../../store/actionreducers/company'
import ReduxCity from '../../../../store/actionreducers/city'
import ReduxPricePlan from '../../../../store/actionreducers/pricePlan'

// Components
import VipList from './VipList'
import ContactsHeader from './VipHeader'
import VipDialog from './VipDialog'
import GroupDialog from '../group/GroupDialog'
import UseRecordDialog from './UseRecordDialog'
import JoinClubDialog from './JoinClubDialog'
import UecareAlertDialog from "../../../../components/UecareAlertDialog"
import UecareFAB from "../../../../components/UecareFAB"
import {constDataDialogs} from "../../../../constants"
import {LinearProgress, TablePagination, Typography } from '@material-ui/core'
import OccDialog from './OccDialog'
import SystemEmailDialog from './SystemEmailDialog'
import KeywordSearchBar from "../../../../components/KeywordSearchBar";
import FilterBars from "../../../../components/FilterBars";

const searchFieldOptions = [
    { displayText: '搜身份證', searchField: 'id_no'},
    { displayText: '搜姓名', searchField: 'name'},
    { displayText: '搜Email', searchField: 'email'},
    { displayText: '搜手機號碼', searchField: 'phone_number'}
]

const filterOptions = [
    { displayText: '搜身份證', searchField: 'id_no'},
    { displayText: '搜姓名', searchField: 'name'},
    { displayText: '搜Email', searchField: 'email'},
    { displayText: '搜手機號碼', searchField: 'phone_number'}
]

class VipsApp extends Component {
    state = {
        pricePlanTabs: [],
        currentPage: 0,
        limit: 10,
        searchField: '',
        searchKeyword: '',
        filterBars: [],
        filters: {},
    };

    async getPricePlanList() {
        const { pricePlanList, getPricePlanList, user } = this.props

        // Getting price plans from DB
        const pricePlans = (!pricePlanList || pricePlanList.length === 0)
            ? await getPricePlanList()
            : pricePlanList

        // Only show price plans that the user can see
        const userPricePlans = user.callCenterPricePlan.map((pricePlan) => pricePlan.id)
        const pricePlanTabs = pricePlans.filter( pricePlan => {
            if (userPricePlans.length === 0) return true
            return (userPricePlans.indexOf(pricePlan.id) > -1)
        })
        pricePlanTabs.push({id: '', name: '全部'})

        // simplify the price plans array for filter options
        const pricePlanOptions = pricePlanTabs.map(ppt => {
            return { displayText: ppt.name, value: ppt.id }
        })
        return { pricePlanTabs, pricePlanOptions }
    }

    async componentDidMount() {
        const { getVips } = this.props
        const { limit, searchType, searchKeyword } = this.state

        await this.initialization()
        await getVips({ offset: 0, limit, searchType, searchKeyword })
    }

    // on change the page number at the footer pagination
    async onPageNumberChange(newPageNumber) {
        const { limit, searchField, searchKeyword, filters} = this.state
        const { getVips } = this.props
        this.setState({ currentPage: newPageNumber})
        await getVips({ limit, offset: newPageNumber*limit, searchField, searchKeyword, ...filters })
    }

    // on change the rows per page value at the footer dropdown
    async onLimitChange(newLimit) {
        const { currentPage, searchField, searchKeyword, limit, filters } = this.state
        const { getVips } = this.props
        this.setState({ limit: newLimit })
        await getVips({ limit: newLimit, offset: currentPage*limit, searchField, searchKeyword, ...filters })
    }

    // on change the filter options
    async onFiltersChange(field, value) {
        const { searchField, searchKeyword, limit, currentPage, filters } = this.state
        const { getVips } = this.props
        const newFilters = { ...filters }
        newFilters[field] = value
        this.setState({ filters: newFilters})
        await getVips({ limit, offset: currentPage*limit, searchField, searchKeyword, ...newFilters})
    }

    // on click one of the search buttons (each button indicates searching on different fields)
    async onClickSearchButton(searchField, searchKeyword ) {
        const { limit, filterBars, filters } = this.state
        const { getVips } = this.props
        if (searchField === '') {
            this.initializeFilters(filterBars)
            await getVips({ limit, offset: 0, searchField, searchKeyword })
        } else {
            await getVips({limit, offset: 0, searchField, searchKeyword, ...filters})
        }
        this.setState({searchField, searchKeyword, currentPage: 0})
    }

    // initialize filters
    initializeFilters(filterBars) {
        let tempFilters = {}
        filterBars.map(filter => {
            tempFilters[filter.value] = ''
        })
        this.setState({ filters: tempFilters })
        return tempFilters
    }

    // fetch global variables from db
    async initialization() {
        const { getCompanies, getGroupTypes, getMissionPriceTypes, getCities } = this.props

        // Initialize price plans tabs
        const { pricePlanTabs, pricePlanOptions } = await this.getPricePlanList()
        this.setState({ pricePlanTabs })

        const filterBars = [
            {
                title: '專案',
                options: pricePlanOptions,
                value: 'fk_price_plan_id',
            }
        ]
        await this.initializeFilters(filterBars)
        this.setState({ filterBars })

        try {
            this.setState({ isLoading: true })
            await Promise.all([
                getCompanies(),
                getGroupTypes(),
                getMissionPriceTypes(),
                getCities(),
            ])
        } finally {
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { classes, openDataDialog, vips, numberOfRecords, refreshVips } = this.props
        const { pricePlanTabs=[], currentPage, limit, searchField, filterBars, filters } = this.state

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <ContactsHeader
                            pageLayout={() => this.pageLayout}
                            reload={() => refreshVips()}/>
                    }
                    content={
                        <div>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <div className="p-16">
                                <FilterBars
                                    filterBars={filterBars}
                                    onFilterSelected = {(field, value) => this.onFiltersChange(field, value)}
                                    filters={filters}
                                />
                                <KeywordSearchBar
                                    searchField={searchField}
                                    searchFieldOptions={searchFieldOptions}
                                    onClickSearchButton={(searchField, searchKeyword) => this.onClickSearchButton(searchField, searchKeyword)}
                                />

                                <VipList
                                    vips={vips}
                                    limit={limit}
                                    pricePlanTabs={pricePlanTabs}
                                />
                                <div className='flex flex-row justify-between items-center'>
                                    <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                                        <div className="flex items-center">
                                            <FuseAnimate animation="transition.slideLeftIn" delay={500}>
                                                <Typography className='pl-8'>
                                                    {`總共 ${numberOfRecords} 筆資料`}
                                                </Typography>
                                            </FuseAnimate>
                                        </div>
                                    </FuseAnimate>
                                    <TablePagination
                                        component="div"
                                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                        count={numberOfRecords}
                                        onChangePage={(event, page) => this.onPageNumberChange(page)}
                                        page={currentPage}
                                        rowsPerPage={limit}
                                        onChangeRowsPerPage={(event) => this.onLimitChange(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <UecareFAB
                        icon='person_add'
                        color='#249f8b'
                        onClick={() => {
                            openDataDialog({type: 'new', name: constDataDialogs.name.vipDialog});
                        }}/>
                </FuseAnimate>
                <VipDialog/>
                <GroupDialog/>
                <UseRecordDialog/>
                <JoinClubDialog/>
                <UecareAlertDialog/>
                <OccDialog/>
                <SystemEmailDialog />
            </React.Fragment>
        )
    };
}

const styles = () => ({
    root: {},
    layoutContentCardWrapper: {
        padding: 16,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        getVips: ReduxVip.ActionCreator.getVips,
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        getCities: ReduxCity.ActionCreator.getCities,
        getGroupTypes: ReduxGroupType.ActionCreator.getGroupTypes,
        getMissionPriceTypes: ReduxMissionPriceType.ActionCreator.getMissionPriceTypes,
        getPricePlanList: ReduxPricePlan.ActionCreator.getPricePlans,
    }, dispatch);
}

function mapStateToProps({ vip: { vips, numberOfRecords }, auth, pricePlan }) {
    return {
        vips,
        numberOfRecords,
        user: auth.user,
        pricePlanList: pricePlan.list,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(VipsApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/VipsApp.js